import {
  formatCategoryName,
  formatCompactCurrency,
  formatCurrency,
  formatPercent,
} from "./analyticsUtils";

const AnalyticsBreakdownTable = ({
  view,
  rows = [],
  loading,
  error,
  compareYear,
}) => {
  const columnCount = view === "trend" ? (compareYear ? 4 : 2) : 5;

  return (
    <div className="rounded-3xl bg-white p-5 shadow">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-zinc-900">
          {view === "trend" ? "Monthly Breakdown" : "Category Breakdown"}
        </h2>
        <p className="text-sm text-zinc-500">
          {view === "trend"
            ? "Month-by-month values for the selected category using payment month buckets."
            : "Range totals, transaction counts, and averages by category."}
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-50 text-left">
            <tr>
              {view === "trend" ? (
                <>
                  <th className="px-4 py-3 font-medium">Month</th>
                  <th className="px-4 py-3 font-medium text-right">Value</th>
                  {compareYear ? (
                    <>
                      <th className="px-4 py-3 font-medium text-right">
                        {compareYear}
                      </th>
                      <th className="px-4 py-3 font-medium text-right">
                        Delta
                      </th>
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  <th className="px-4 py-3 font-medium">Category</th>
                  <th className="px-4 py-3 font-medium text-right">Total</th>
                  <th className="px-4 py-3 font-medium text-right">
                    Transactions
                  </th>
                  <th className="px-4 py-3 font-medium text-right">
                    Avg / Txn
                  </th>
                  <th className="px-4 py-3 font-medium text-right">Share</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="px-4 py-6 text-zinc-500" colSpan={columnCount}>
                  Loading breakdown...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td className="px-4 py-6 text-red-600" colSpan={columnCount}>
                  {error}
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td className="px-4 py-6 text-zinc-500" colSpan={columnCount}>
                  No analytics data for the selected filters.
                </td>
              </tr>
            ) : view === "trend" ? (
              rows.map((row) => (
                <tr className="border-t" key={row.paymentMonth || row.month}>
                  <td className="px-4 py-3 font-medium text-zinc-800">
                    <div>{row.month}</div>
                    {row.paymentMonth ? (
                      <div className="text-xs font-normal text-zinc-400">
                        {row.paymentMonth}
                      </div>
                    ) : null}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatCurrency(row.value)}
                  </td>
                  {compareYear ? (
                    <>
                      <td className="px-4 py-3 text-right">
                        {formatCurrency(row.compareValue)}
                      </td>
                      <td
                        className={`px-4 py-3 text-right font-medium ${
                          row.delta >= 0 ? "text-emerald-600" : "text-red-600"
                        }`}
                      >
                        {`${row.delta >= 0 ? "+" : ""}${formatCompactCurrency(
                          row.delta
                        )}`}
                      </td>
                    </>
                  ) : null}
                </tr>
              ))
            ) : (
              rows.map((row) => (
                <tr className="border-t" key={row.category}>
                  <td className="px-4 py-3 font-medium text-zinc-800">
                    {formatCategoryName(row.label || row.category)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatCurrency(row.totalAmount)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {Number(row.totalTransactions ?? 0).toLocaleString("en-MY")}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatCurrency(row.averageAmount)}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {formatPercent(row.share)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnalyticsBreakdownTable;
